<template>
  <van-tabbar
    v-if="show"
    v-model="active"
    class="custom-tabbar"
    fixed
    :border="true"
    z-index="999"
    safe-area-inset-bottom
  >
    <van-tabbar-item
      v-for="(tab, index) in tabs"
      :key="index"
      :to="tab.to"
    >
      <template #icon="props">
        <div
          class="tab-icon-wrap"
          :class="{ 'tab-icon-wrap--active': props.active }"
        >
          <img
            :src="props.active ? tab.iconActive : tab.iconInactive"
            :alt="tab.alt"
            class="tab-icon-img"
          />
        </div>
      </template>

      {{ tab.alt }}

    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
const TABS = [
  {
    to: "/Home",
    alt: "Home",
    iconInactive:
      "https://midnightdesires.vip/tupian/1wxz.png",
    iconActive:
      "https://midnightdesires.vip/tupian/1xz.png",
  },
  {
    to: "/ChooseEntry",
    alt: "Notifications",
    iconInactive:
      "https://midnightdesires.vip/tupian/2未选中.png",
    iconActive:
      "https://ik.imagekit.io/nmil2wj2k/%E4%B8%8B%E8%BD%BD%20(23).png?updatedAt=1780093708527",
  },
  {
    to: "/Lottery",
    alt: "Dating",
    iconInactive:
      "https://midnightdesires.vip/tupian/3未选中.png",
    iconActive:
      "https://ik.imagekit.io/nmil2wj2k/%E4%B8%8B%E8%BD%BD%20(9).png?updatedAt=1780093709158",
  },
  {
    to: "/Video",
    alt: "Videos",
    iconInactive:
      "https://midnightdesires.vip/tupian/4未选中.png",
    iconActive:
      "https://ik.imagekit.io/nmil2wj2k/%E4%B8%8B%E8%BD%BD%20(27).png?updatedAt=1780093708480",
  },
  {
    to: "/Mine",
    alt: "My Account",
    iconInactive:
      "https://midnightdesires.vip/tupian/5未选中.png",
    iconActive:
      "https://ik.imagekit.io/nmil2wj2k/%E4%B8%8B%E8%BD%BD%20(35).png?updatedAt=1780093708485",
  },
];

export default {
  data() {
    return {
      show: false,
      active: 0,
      tabs: TABS,
    };
  },
  watch: {
    $route(to) {
      this.syncTabFromRoute(to.name);
    },
  },
  created() {
    this.syncTabFromRoute(this.$route.name);
  },
  methods: {
    syncTabFromRoute(name) {
      if (name === "home") {
        this.active = 0;
        this.show = true;
      } else if (name === "chooseEntry" || name === "choose") {
        this.active = 1;
        this.show = true;
      } else if (name === "lotteryEntry" || name === "Lottery") {
        this.active = 2;
        this.show = true;
      } else if (name === "video") {
        this.active = 3;
        this.show = true;
      } else if (name === "mine") {
        this.active = 4;
        this.show = true;
      } else {
        this.show = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
@tabbar-h: 120px;
@pill-max-w: 100px;
@pill-h: 72px;
@pill-radius: 18px;
@icon-size: 52px;

.custom-tabbar {
  width: 100% !important;
  height: @tabbar-h !important;
  padding: 6px 6px calc(6px + env(safe-area-inset-bottom, 0px)) !important;
  background: #fff !important;
  box-sizing: border-box;
  overflow: hidden;

  :deep(.van-tabbar-item) {
    flex: 1 1 0;
    min-width: 0;
    max-width: 20%;
    height: @tabbar-h;
    padding: 0 2px !important;
    background: transparent !important;
    overflow: hidden;
  }

  :deep(.van-tabbar-item--active),
  :deep(.van-tabbar-item.active) {
    background: transparent !important;
  }

  :deep(.van-tabbar-item__icon) {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 72px;
    margin: 0 !important;
    font-size: 0;
  }

  :deep(.van-tabbar-item__text) {
    display: block !important;
    font-size: 16px !important;
    color: #999;
    margin-top: 4px;
    line-height: 20px;
    font-weight: 500;
  }

  :deep(.van-badge__wrapper) {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }
}

.tab-icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: @pill-max-w;
  height: @pill-h;
  margin: 0 auto;
  border-radius: @pill-radius;
  background: rgba(232, 154, 179, 0.07);
  box-sizing: border-box;
  transition: background 0.2s ease;

  &--active {
    background: rgb(232, 154, 179);
  }
}

.tab-icon-img {
  width: @icon-size;
  height: @icon-size;
  object-fit: contain;
  display: block;
  pointer-events: none;
}
</style>
